/**
 * Constructs the PosLog JSON payload for a receipt reprint event,
 * matching the ROP data/ingest/v1 ControlTransaction schema.
 *
 * See: reprint_event_discovery_plan for full field mapping.
 */

const stripSiretNumber = (businessUnit) => {
  if (!businessUnit) return businessUnit;
  const { SiretNumber, ...rest } = businessUnit;
  return rest;
};

const getTimezoneOffset = (isoDateString) => {
  if (!isoDateString) return '+00:00';
  const match = isoDateString.match(/([+-]\d{2}:\d{2})$/);
  return match ? match[1] : '+00:00';
};

const formatDateTimeWithOffset = (date, offset) => {
  const pad = (n, len = 2) => String(n).padStart(len, '0');
  const y = date.getFullYear();
  const mo = pad(date.getMonth() + 1);
  const d = pad(date.getDate());
  const h = pad(date.getHours());
  const mi = pad(date.getMinutes());
  const s = pad(date.getSeconds());
  return `${y}-${mo}-${d}T${h}:${mi}:${s}.000${offset}`;
};

const formatBusinessDayDate = (date) => {
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

const buildReprintEventPayload = (transaction, sessionContext, now = new Date()) => {
  const { operatorId, workstation: sessionWorkstation, tillId } = sessionContext;
  const businessUnit = stripSiretNumber(transaction.BusinessUnit);
  const tzOffset = getTimezoneOffset(transaction.EndDateTime);
  const reprintDateTime = formatDateTimeWithOffset(now, tzOffset);
  const businessDayDate = formatBusinessDayDate(now);

  return {
    POSLog: {
      Transaction: {
        BeginDateTime: reprintDateTime,
        BusinessDayDate: businessDayDate,
        BusinessUnit: businessUnit,
        ControlTransaction: {
          ReceiptReprint: {
            TransactionLinks: [{
              BeginDateTime: `${transaction.BusinessDayDate}T00:00:00.000${tzOffset}`,
              BusinessUnit: businessUnit,
              EndDateTime: transaction.EndDateTime,
              SequenceNumber: transaction.SequenceNumber,
              TransactionID: transaction.TransactionID,
              Workstation: {
                DeviceID: transaction.Workstation?.DeviceID,
                ID: transaction.Workstation?.ID,
              },
            }],
            TypeCode: 'ReceiptReprint',
          },
        },
        EndDateTime: reprintDateTime,
        Operator: { ID: operatorId },
        SequenceNumber: transaction.SequenceNumber,
        TillID: tillId,
        TransactionID: transaction.TransactionID,
        Workstation: {
          DeviceID: sessionWorkstation?.deviceId,
          ID: sessionWorkstation?.id,
          SerialNumber: sessionWorkstation?.serialNumber,
          TypeCode: sessionWorkstation?.typeCode,
        },
      },
    },
  };
};

module.exports = { buildReprintEventPayload, getTimezoneOffset, Test: { getTimezoneOffset, stripSiretNumber } };
